module.exports = __webpack_public_path__ + "img/sem-tubete-mobile.54dc1f13.png";